import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Title } from 'shared';
import { useTranslation } from 'hooks/useTranslation';

import { AuthPageLayout } from 'features/auth/components/AuthPageLayout';
import { ChangePasswordForm } from 'features/auth/components/ChangePasswordForm';
import useAuth from 'features/auth/hooks/useAuth';

import { useStyles } from './styles';

export const GeneratePasswordPage = () => {
  const classes = useStyles();
  const { t } = useTranslation('auth');
  const { onConfirmRegistration, isLoading } = useAuth();

  return (
    <>
      <Title title={t('generatePassword')} />

      <AuthPageLayout title={t('welcomeToRewardsBy')} additionalContentClassName={classes.generatePasswordFormWrapper}>
        <Grid className={classes.passwordContainer}>
          <Typography className={classes.title} variant={'h3'}>
            {t('generatePassword')}
          </Typography>
          <ChangePasswordForm
            onFormSubmit={onConfirmRegistration}
            isLoading={isLoading}
            isFirstLogin={true}
            buttonTitle={t('setPassword')}
          />
        </Grid>
      </AuthPageLayout>
    </>
  );
};
